import * as actions from './shop/actions'
import * as mutations from './shop/mutations'
import * as getters from './shop/getters'

import { dataProps } from './shop/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps)),
    store_address: null
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/shop.js